// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-items-list-save-filter-dialog-panel .footer .mat-mdc-dialog-actions {
  padding: 0;
}

.fi-items-list-save-filter-dialog {
  display: block;
  padding: 7px 0 0 0;
}
.fi-items-list-save-filter-dialog .mat-mdc-form-field {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-items-list/fi-items-list-filter/fi-items-list-filter/fi-items-list-save-filter-dialog/fi-items-list-save-filter-dialog.component.scss"],"names":[],"mappings":"AACI;EACI,UAAA;AAAR;;AAIA;EACI,cAAA;EACA,kBAAA;AADJ;AAEI;EACI,WAAA;AAAR","sourcesContent":[".fi-items-list-save-filter-dialog-panel {\r\n    .footer .mat-mdc-dialog-actions {\r\n        padding: 0;\r\n    }\r\n}\r\n\r\n.fi-items-list-save-filter-dialog {\r\n    display: block;\r\n    padding: 7px 0 0 0;\r\n    .mat-mdc-form-field {\r\n        width: 100%;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
